export type AdminTab = 'users' | 'groups' | 'roles' | 'createUser';
export const AdminTabs = {
  Users: 'users' as AdminTab,
  Groups: 'groups' as AdminTab,
  Roles: 'roles' as AdminTab,
  CreateUser: 'createUser' as AdminTab,
};
